import { TOURS } from './registry';
import type { TourDefinition } from './types';

interface ServerTour {
  slug: string;
  completed_web_at: string | null;
}

/**
 * The `autoStart` tour whose `path` is `pathname`, or null. Fails closed: the BE row
 * must be listed (published) and not completed on web, and this device must
 * not have finished it already (the local flag covers a lost completion POST).
 */
export function pickAutoStartTour(
  pathname: string,
  serverTours: readonly ServerTour[],
  hasSeen: (tour: TourDefinition) => boolean
): TourDefinition | null {
  const tours: readonly TourDefinition[] = Object.values(TOURS);
  return (
    tours.find((tour) => {
      if (!tour.autoStart || tour.path !== pathname) return false;
      const row = serverTours.find((t) => t.slug === tour.slug);
      return row !== undefined && row.completed_web_at === null && !hasSeen(tour);
    }) ?? null
  );
}
